import { TRESPONSE_OPERATION_BREAKDOWN_DETAILS_DATA } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';

export const OPERATION_BREAKDOWN_DETAILS_TABLE_MODEL = {
  createModel: (
    headers: TRESPONSE_OPERATION_BREAKDOWN_DETAILS_DATA['headers'],
    data: TRESPONSE_OPERATION_BREAKDOWN_DETAILS_DATA['operationBreakdowns'][number]['operations'],
  ) => {
    return ModifiersZTableModel.createTableModel(
      data,
      {
        padding: 8,
        headerConfig: headers.map((h) => ({
          type: 'TEXT_CELL' as const,
          text: h.displayName,
          align: 'center' as const,
          widthInPx: 100,
        })),
      },
      (item) => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: headers.map((h) => ({
            type: 'TEXT_CELL' as const,
            text: item[h.key] ?? '- -',
            align: 'center' as const,
          })),
        };
      },
    );
  },
};
